import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const InputBox = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    marginTop:8,
    marginBottom:24,

    "& fieldset": {
      borderColor: "primary", // Default border color
      borderRadius:8,
      border:'1px solid #6B6B6B',
      // paddingTop:8,
      // paddingBottom:8
    },
    "&:hover fieldset": {
      borderColor: "primary", // Hover border color
    },
    "&.Mui-focused fieldset": {
      borderColor: "primary", // Focused border color
    },
  },
  "& .MuiInputBase-root":{

  },

  "& .MuiInputLabel-root": {
    color: "gray", // Label color
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "primary", // Focused label color
  },
});

export default InputBox;
